import * as Types from '../../../../../types.generated';

import { gql } from '@apollo/client';
import { AvatarProfileImageFragmentDoc } from '../../../../../fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCourseCommentThreadsQueryVariables = Types.Exact<{
  courseVersionId: Types.Scalars['Int']['input'];
}>;


export type GetCourseCommentThreadsQuery = { __typename?: 'Query', AdminCommentThreads: Array<{ __typename?: 'CommentThread', id: string, prompt?: { __typename?: 'Prompt', uuid: string } | null, comments: Array<{ __typename?: 'Comment', id: string, text: string, createdAt: string, createdBy: { __typename?: 'Employee', id: number, email?: string | null, firstName: string, name: string, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null }, mentions: Array<{ __typename?: 'CommentMention', id: string, mentionedUser: { __typename?: 'Employee', id: number, name: string } }> }> }> };

export type CreatePromptCommentThreadMutationVariables = Types.Exact<{
  promptUuid: Types.Scalars['String']['input'];
  comment: Types.CommentInput;
}>;


export type CreatePromptCommentThreadMutation = { __typename?: 'Mutation', createPromptCommentThread: { __typename?: 'CommentThreadMutationResult', success: boolean, commentThread?: { __typename?: 'CommentThread', id: string, prompt?: { __typename?: 'Prompt', uuid: string } | null, comments: Array<{ __typename?: 'Comment', id: string, text: string, createdAt: string, createdBy: { __typename?: 'Employee', id: number, email?: string | null, firstName: string, name: string, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null }, mentions: Array<{ __typename?: 'CommentMention', id: string, mentionedUser: { __typename?: 'Employee', id: number, name: string } }> }> } | null } };

export type ResolvePromptCommentThreadMutationVariables = Types.Exact<{
  threadId: Types.Scalars['String']['input'];
}>;


export type ResolvePromptCommentThreadMutation = { __typename?: 'Mutation', deleteCommentThread: { __typename?: 'CommentThreadMutationResult', success: boolean, commentThread?: { __typename?: 'CommentThread', id: string, prompt?: { __typename?: 'Prompt', uuid: string } | null, comments: Array<{ __typename?: 'Comment', id: string, text: string, createdAt: string, createdBy: { __typename?: 'Employee', id: number, email?: string | null, firstName: string, name: string, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null }, mentions: Array<{ __typename?: 'CommentMention', id: string, mentionedUser: { __typename?: 'Employee', id: number, name: string } }> }> } | null } };

export type AddCommentToThreadMutationVariables = Types.Exact<{
  threadId: Types.Scalars['String']['input'];
  comment: Types.CommentInput;
}>;


export type AddCommentToThreadMutation = { __typename?: 'Mutation', createComment: { __typename?: 'CommentThreadMutationResult', success: boolean, commentThread?: { __typename?: 'CommentThread', id: string, prompt?: { __typename?: 'Prompt', uuid: string } | null, comments: Array<{ __typename?: 'Comment', id: string, text: string, createdAt: string, createdBy: { __typename?: 'Employee', id: number, email?: string | null, firstName: string, name: string, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null }, mentions: Array<{ __typename?: 'CommentMention', id: string, mentionedUser: { __typename?: 'Employee', id: number, name: string } }> }> } | null } };

export type DeleteCommentMutationVariables = Types.Exact<{
  commentId: Types.Scalars['String']['input'];
}>;


export type DeleteCommentMutation = { __typename?: 'Mutation', deleteComment: { __typename?: 'CommentThreadMutationResult', success: boolean, commentThread?: { __typename?: 'CommentThread', id: string, prompt?: { __typename?: 'Prompt', uuid: string } | null, comments: Array<{ __typename?: 'Comment', id: string, text: string, createdAt: string, createdBy: { __typename?: 'Employee', id: number, email?: string | null, firstName: string, name: string, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null }, mentions: Array<{ __typename?: 'CommentMention', id: string, mentionedUser: { __typename?: 'Employee', id: number, name: string } }> }> } | null } };

export type EditCommentMutationVariables = Types.Exact<{
  commentId: Types.Scalars['String']['input'];
  comment: Types.CommentInput;
}>;


export type EditCommentMutation = { __typename?: 'Mutation', editComment: { __typename?: 'CommentThreadMutationResult', success: boolean, commentThread?: { __typename?: 'CommentThread', id: string, prompt?: { __typename?: 'Prompt', uuid: string } | null, comments: Array<{ __typename?: 'Comment', id: string, text: string, createdAt: string, createdBy: { __typename?: 'Employee', id: number, email?: string | null, firstName: string, name: string, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null }, mentions: Array<{ __typename?: 'CommentMention', id: string, mentionedUser: { __typename?: 'Employee', id: number, name: string } }> }> } | null } };

export type CommentThreadFragment = { __typename?: 'CommentThread', id: string, prompt?: { __typename?: 'Prompt', uuid: string } | null, comments: Array<{ __typename?: 'Comment', id: string, text: string, createdAt: string, createdBy: { __typename?: 'Employee', id: number, email?: string | null, firstName: string, name: string, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null }, mentions: Array<{ __typename?: 'CommentMention', id: string, mentionedUser: { __typename?: 'Employee', id: number, name: string } }> }> };

export type CommentFragment = { __typename?: 'Comment', id: string, text: string, createdAt: string, createdBy: { __typename?: 'Employee', id: number, email?: string | null, firstName: string, name: string, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null }, mentions: Array<{ __typename?: 'CommentMention', id: string, mentionedUser: { __typename?: 'Employee', id: number, name: string } }> };

export type CommentMentionFragment = { __typename?: 'CommentMention', id: string, mentionedUser: { __typename?: 'Employee', id: number, name: string } };

export const CommentMentionFragmentDoc = gql`
    fragment CommentMention on CommentMention {
  id
  mentionedUser {
    id
    name
  }
}
    `;
export const CommentFragmentDoc = gql`
    fragment Comment on Comment {
  id
  text
  createdAt
  createdBy {
    id
    email
    firstName
    name
    profileImage {
      ...AvatarProfileImage
    }
  }
  mentions {
    ...CommentMention
  }
}
    ${AvatarProfileImageFragmentDoc}
${CommentMentionFragmentDoc}`;
export const CommentThreadFragmentDoc = gql`
    fragment CommentThread on CommentThread {
  id
  prompt {
    uuid
  }
  comments {
    ...Comment
  }
}
    ${CommentFragmentDoc}`;
export const GetCourseCommentThreadsDocument = gql`
    query getCourseCommentThreads($courseVersionId: Int!) {
  AdminCommentThreads(courseVersionId: $courseVersionId) {
    ...CommentThread
  }
}
    ${CommentThreadFragmentDoc}`;

/**
 * __useGetCourseCommentThreadsQuery__
 *
 * To run a query within a React component, call `useGetCourseCommentThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseCommentThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseCommentThreadsQuery({
 *   variables: {
 *      courseVersionId: // value for 'courseVersionId'
 *   },
 * });
 */
export function useGetCourseCommentThreadsQuery(baseOptions: Apollo.QueryHookOptions<GetCourseCommentThreadsQuery, GetCourseCommentThreadsQueryVariables> & ({ variables: GetCourseCommentThreadsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseCommentThreadsQuery, GetCourseCommentThreadsQueryVariables>(GetCourseCommentThreadsDocument, options);
      }
export function useGetCourseCommentThreadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseCommentThreadsQuery, GetCourseCommentThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseCommentThreadsQuery, GetCourseCommentThreadsQueryVariables>(GetCourseCommentThreadsDocument, options);
        }
export type GetCourseCommentThreadsQueryHookResult = ReturnType<typeof useGetCourseCommentThreadsQuery>;
export type GetCourseCommentThreadsLazyQueryHookResult = ReturnType<typeof useGetCourseCommentThreadsLazyQuery>;
export type GetCourseCommentThreadsQueryResult = Apollo.QueryResult<GetCourseCommentThreadsQuery, GetCourseCommentThreadsQueryVariables>;
export const CreatePromptCommentThreadDocument = gql`
    mutation CreatePromptCommentThread($promptUuid: String!, $comment: CommentInput!) {
  createPromptCommentThread(promptUuid: $promptUuid, comment: $comment) {
    success
    commentThread {
      ...CommentThread
    }
  }
}
    ${CommentThreadFragmentDoc}`;
export type CreatePromptCommentThreadMutationFn = Apollo.MutationFunction<CreatePromptCommentThreadMutation, CreatePromptCommentThreadMutationVariables>;

/**
 * __useCreatePromptCommentThreadMutation__
 *
 * To run a mutation, you first call `useCreatePromptCommentThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePromptCommentThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPromptCommentThreadMutation, { data, loading, error }] = useCreatePromptCommentThreadMutation({
 *   variables: {
 *      promptUuid: // value for 'promptUuid'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useCreatePromptCommentThreadMutation(baseOptions?: Apollo.MutationHookOptions<CreatePromptCommentThreadMutation, CreatePromptCommentThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePromptCommentThreadMutation, CreatePromptCommentThreadMutationVariables>(CreatePromptCommentThreadDocument, options);
      }
export type CreatePromptCommentThreadMutationHookResult = ReturnType<typeof useCreatePromptCommentThreadMutation>;
export type CreatePromptCommentThreadMutationResult = Apollo.MutationResult<CreatePromptCommentThreadMutation>;
export type CreatePromptCommentThreadMutationOptions = Apollo.BaseMutationOptions<CreatePromptCommentThreadMutation, CreatePromptCommentThreadMutationVariables>;
export const ResolvePromptCommentThreadDocument = gql`
    mutation ResolvePromptCommentThread($threadId: String!) {
  deleteCommentThread(threadId: $threadId) {
    success
    commentThread {
      ...CommentThread
    }
  }
}
    ${CommentThreadFragmentDoc}`;
export type ResolvePromptCommentThreadMutationFn = Apollo.MutationFunction<ResolvePromptCommentThreadMutation, ResolvePromptCommentThreadMutationVariables>;

/**
 * __useResolvePromptCommentThreadMutation__
 *
 * To run a mutation, you first call `useResolvePromptCommentThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolvePromptCommentThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolvePromptCommentThreadMutation, { data, loading, error }] = useResolvePromptCommentThreadMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useResolvePromptCommentThreadMutation(baseOptions?: Apollo.MutationHookOptions<ResolvePromptCommentThreadMutation, ResolvePromptCommentThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolvePromptCommentThreadMutation, ResolvePromptCommentThreadMutationVariables>(ResolvePromptCommentThreadDocument, options);
      }
export type ResolvePromptCommentThreadMutationHookResult = ReturnType<typeof useResolvePromptCommentThreadMutation>;
export type ResolvePromptCommentThreadMutationResult = Apollo.MutationResult<ResolvePromptCommentThreadMutation>;
export type ResolvePromptCommentThreadMutationOptions = Apollo.BaseMutationOptions<ResolvePromptCommentThreadMutation, ResolvePromptCommentThreadMutationVariables>;
export const AddCommentToThreadDocument = gql`
    mutation AddCommentToThread($threadId: String!, $comment: CommentInput!) {
  createComment(threadId: $threadId, comment: $comment) {
    success
    commentThread {
      ...CommentThread
    }
  }
}
    ${CommentThreadFragmentDoc}`;
export type AddCommentToThreadMutationFn = Apollo.MutationFunction<AddCommentToThreadMutation, AddCommentToThreadMutationVariables>;

/**
 * __useAddCommentToThreadMutation__
 *
 * To run a mutation, you first call `useAddCommentToThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCommentToThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCommentToThreadMutation, { data, loading, error }] = useAddCommentToThreadMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useAddCommentToThreadMutation(baseOptions?: Apollo.MutationHookOptions<AddCommentToThreadMutation, AddCommentToThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCommentToThreadMutation, AddCommentToThreadMutationVariables>(AddCommentToThreadDocument, options);
      }
export type AddCommentToThreadMutationHookResult = ReturnType<typeof useAddCommentToThreadMutation>;
export type AddCommentToThreadMutationResult = Apollo.MutationResult<AddCommentToThreadMutation>;
export type AddCommentToThreadMutationOptions = Apollo.BaseMutationOptions<AddCommentToThreadMutation, AddCommentToThreadMutationVariables>;
export const DeleteCommentDocument = gql`
    mutation DeleteComment($commentId: String!) {
  deleteComment(commentId: $commentId) {
    success
    commentThread {
      ...CommentThread
    }
  }
}
    ${CommentThreadFragmentDoc}`;
export type DeleteCommentMutationFn = Apollo.MutationFunction<DeleteCommentMutation, DeleteCommentMutationVariables>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useDeleteCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, options);
      }
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = Apollo.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const EditCommentDocument = gql`
    mutation EditComment($commentId: String!, $comment: CommentInput!) {
  editComment(commentId: $commentId, comment: $comment) {
    success
    commentThread {
      ...CommentThread
    }
  }
}
    ${CommentThreadFragmentDoc}`;
export type EditCommentMutationFn = Apollo.MutationFunction<EditCommentMutation, EditCommentMutationVariables>;

/**
 * __useEditCommentMutation__
 *
 * To run a mutation, you first call `useEditCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCommentMutation, { data, loading, error }] = useEditCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useEditCommentMutation(baseOptions?: Apollo.MutationHookOptions<EditCommentMutation, EditCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCommentMutation, EditCommentMutationVariables>(EditCommentDocument, options);
      }
export type EditCommentMutationHookResult = ReturnType<typeof useEditCommentMutation>;
export type EditCommentMutationResult = Apollo.MutationResult<EditCommentMutation>;
export type EditCommentMutationOptions = Apollo.BaseMutationOptions<EditCommentMutation, EditCommentMutationVariables>;